import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportForm from "../common/support_form.js";
import IllumioSupportUtils from "../common/support_utils.js";

export class ProfileModel extends IllumioEventEmitter {
    constructor() {
        super();

        console.debug('Initialized ProfileModel');
        this.data = null;

        this.requiredFields = [];

        // this.loadAjaxEvent = new IllumioEvent(this);
        // this.loadAjaxEvent.attach(readData.bind(this));
        this.on('loadAjax', this.readData.bind(this));

        // this.writeAjaxEvent = new IllumioEvent(this);
        // this.writeAjaxEvent.attach(writeData.bind(this));
        this.on('writeAjax', this.writeData.bind(this));

        // this.displayProfileDataEvent = new IllumioEvent(this);
    }

    readData(payload) {
        console.debug('ProfileModel.loadData()');
        const url = payload.theForm.action;
        $.ajax({
            method: 'get',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: url,
            beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.commonAjaxErrorHandler.bind(this),
            success: this.loadAjaxSuccessHandler.bind(this),
        });
    }

    commonAjaxBeforeSendHandler(jqXHR, settings) {
        console.debug(jqXHR);
        console.debug(settings);
        console.debug(this.data);
    }
    
    commonAjaxErrorHandler(jqXHR, textStatus, errorThrown) {
        // console.debug(jqXHR);
        console.debug(textStatus);
        console.debug(errorThrown);

        this.data = jqXHR.responseJSON;
        // this.displayProfileDataEvent.notify();
        this.emit('displayProfileData', {});
    }
    
    loadAjaxSuccessHandler(data, textStatus, jqXHR) {
        console.debug('ProfileModel.loadAjaxSuccessHandler(): ');
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);

        this.data = data;
        // this.displayProfileDataEvent.notify();
        this.emit('displayProfileData', {});
    }

    writeData(inputs) {
        console.debug('ProfileModel.writeData() ');
        this.generatePayload(inputs.theForm);
        let url = inputs.theForm.action;
        let method = 'put';
        if (url.match(/\/new$/)) {
            const replacement = (this.data && this.data.id && this.data.id.length>0) ? '/'+this.data.id : '';
            url = url.replace(/\/new$/, replacement);
            method = (replacement.length>0) ? 'put' : 'post';
        }
        $.ajax({
            method: method,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(this.payload),
            url: url,
            beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.commonAjaxErrorHandler.bind(this),
            success: this.writeAjaxSuccessHandler.bind(this),
        });
    }

    generatePayload(theForm) {
        console.debug('ProfileModel.generatePayload()');
        const csrf = IllumioSupportForm.getCsrf();
        const payload = {
            authenticity_token: (csrf) ? csrf['authenticity_token'] : null,
            first_name: theForm['first_name'].value,
            last_name: theForm['last_name'].value,
            title: theForm['title'].value,
            phone: theForm['phone'].value,
            mobile: theForm['mobile'].value,
        };
        if (this.data && this.data.id) {
            payload['id'] = this.data.id;
        }
        if (theForm['email'] && theForm['email'].tagName==='INPUT' && theForm['email'].type==='email') {
            payload['email'] = theForm['email'].value;
        }
        if (this.data && this.data.metadata && this.data.metadata.full_profile) {
            payload['street'] = theForm['street'].value;
            payload['city'] = theForm['city'].value;
            payload['zip'] = theForm['zip'].value;
            if (theForm['country_code'].selectedIndex>0) {
                payload['country_code'] = theForm['country_code'].options[theForm['country_code'].selectedIndex].value;
            }
            if (theForm['state_code'].disabled===false && theForm['state_code'].selectedIndex>0) {
                payload['state_code'] = theForm['state_code'].options[theForm['state_code'].selectedIndex].value;
            }
            if (theForm['timezone'].selectedIndex>0) {
                payload['timezone'] = theForm['timezone'].options[theForm['timezone'].selectedIndex].value;
            }
            if (theForm['enable_mfa']) {
                payload['enable_mfa'] = theForm['enable_mfa'].checked
            }
        }
        this.payload = payload;
        return payload;
    }
    
    writeAjaxSuccessHandler(data, textStatus, jqXHR) {
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);

        this.data = data;
        // this.displayProfileDataEvent.notify();
        this.emit('displayProfileData', {});
    }

        /**
         * Public method
         * Lookup the timezone in the metadata. Returns the timezone value when matching the web_code.
         */
        getTimezoneDisplayValue() {
            let timezoneDisplayValue = null;
            if (this.data && this.data.profile && this.data.profile.timezone && this.data.metadata && this.data.metadata.timezone) {
                const timezonesForEachHandler = function(timezone) {
                    if (this.data.profile.timezone===timezone.web_code) {
                        timezoneDisplayValue = timezone.value;
                    }
                }
                this.data.metadata.timezone.forEach(timezonesForEachHandler.bind(this));
            }
            return timezoneDisplayValue;
        }

        /**
         * Public method
         * Lookup states array in metadata. Return the states array when matching the country.value.
         */
        getStates(countryValue) {
            let states = null;
            let countryStateForEachHandler = null;
            if (countryValue) {
                countryStateForEachHandler = function(country) {
                    if (countryValue && country.value===countryValue) {
                        states = country.states;
                    }
                }
            } else {
                countryStateForEachHandler = function(country) {
                    if (country.value===this.data.profile.country_code) {
                        states = country.states;
                    }
                }
            }
            this.data.metadata.country_state.forEach(countryStateForEachHandler.bind(this));
            return states;
        }
}

export class ProfileView extends IllumioEventEmitter {
    constructor(model) {
        super();

        console.debug('Initialized ProfileView');
        this.model = model;

        // formMode Options: show, new, edit
        this.formMode = 'show';
        this.isFirstTime = true;
    
        this.fullProfileDivs = document.getElementsByClassName('ilo-full-profile');
        this.contactDivs = document.getElementsByClassName('ilo-contact');
        this.actionButtons = document.getElementsByClassName('actionButtons');

        this.theForm = document.getElementById('theProfileForm');
        this.theMessage = document.getElementById('theMessage');
        this.model.formName = this.theForm.name;

        this.actionButtonDiv = document.getElementById('actionButtonDiv');
        this.initializeWidgetsEvent();

        // this.model.displayProfileDataEvent.attach(displayProfileDataEventHandler.bind(this));
        this.model.on('displayProfileData', this.displayProfileDataEventHandler.bind(this));

        if (document.URL.match(/\/new(\.html)?/)) {
            // Display the blank form.
            this.formMode = 'new';
            this.displayDataFormRow();
            this.toggleContactDisplay();
            this.toggleButtonDisplay();
        } else {
            // this.model.loadAjaxEvent.notify({ theForm: this.theForm });
            this.model.emit('loadAjax', { theForm: this.theForm });
            this.toggleButtonDisability(); // This toggle button disabled to true (i.e, disabled the button)
        }
    }

    startsWithEditMode() {
        const qs = IllumioSupportUtils.getParameters(window.location.search)
        if (qs && qs.edit==='true') {
            return true;
        }
        return false;
    }

    initializeWidgetsEvent() {
        if (this.actionButtonDiv) {
            for (let i=0;i<this.actionButtonDiv.children.length;i++) {
                const element = this.actionButtonDiv.children[i];
                element.style.display = 'none';
                if (element.id) {
                    if (element.id==='addButton') {
                        element.onclick = this.addActionButtonOnClickHandler.bind(this);
                    } else if (element.id==='editButton') {
                        element.onclick = this.editActionButtonOnClickHandler.bind(this);
                    } else if (element.id==='submitEditButton') {
                        element.onclick = this.submitActionButtonOnClickHandler.bind(this);
                    } else if (element.id==='cancelEditButton') {
                        element.onclick = this.cancelEditActionButtonOnClickHandler.bind(this);
                    }
                }
            }
            this.actionButtonDiv.classList.remove('hidden');
        }

        this.theForm['country_code'].onchange = this.countryCodeSelectOnChangeHandler.bind(this);
    }

    validateForm() {
        console.debug('validateForm()');
        console.debug(this);

        let invalidCounter = 0;
        if (this.theForm && this.theForm.elements.length>0) {
            for (let i=0;i<this.theForm.elements.length;i++) {
                if (this.theForm[i].required) {
                    const isValid = IllumioSupportForm.validate(this.theForm[i], true);
                    if (!isValid) {
                        invalidCounter++;
                    }
                }
            }
        }
        return (invalidCounter>0) ? false : true;
    }

    addActionButtonOnClickHandler(event) {
        console.debug('addActionButtonHandler()');

        const isValid = this.validateForm();
        if (isValid) {
            this.toggleButtonDisability();
            // this.model.writeAjaxEvent.notify({ theForm: this.theForm });
            this.model.emit('writeAjax', { theForm: this.theForm });
        }

        event.preventDefault();
    }

    editActionButtonOnClickHandler(event) {
        console.debug('editActionButtonHandler()');
        console.debug(event);
        console.debug(this);

        this.formMode = 'edit'; // Options: show, new, edit

        this.toggleContactDisplay();
        this.toggleButtonDisplay();
        
        event.preventDefault();
    }

    cancelEditActionButtonOnClickHandler(event) {
        console.debug('cancelEditActionButtonOnClickHandler()');
        // console.debug(event);
        // console.debug(this);

        this.formMode = 'show';
        this.toggleContactDisplay();
        this.toggleButtonDisplay();

        event.preventDefault();
    }

    submitActionButtonOnClickHandler(event) {
        console.debug('submitActionButtonOnClickHandler()');
        // console.debug(event);
        // console.debug(this);

        const isValid = this.validateForm();
        if (isValid) {
            this.toggleButtonDisability();
            // this.model.writeAjaxEvent.notify({ theForm: this.theForm });
            this.model.emit('writeAjax', { theForm: this.theForm });
        }

        event.preventDefault();
    }

    countryCodeSelectOnChangeHandler(event) {
        console.debug('countryCodeSelectOnChangeHandler()');
        // console.debug(event);
        // console.debug(this);
        
        const states = this.model.getStates(event.target.value);
        const stateCodeElement = event.target.form['state_code'];
        const selectedStateCode = this.model.data.profile.state_code;
        if (states) {
            stateCodeElement.length = 1;
            const statesForEachHandler = function(item) {
                stateCodeElement[stateCodeElement.options.length] = new Option(item.label, item.value, this.value===selectedStateCode, this.value===selectedStateCode);
            }
            states.forEach(statesForEachHandler.bind(this));
        }
        this.theForm['state_code'].disabled = (states) ? false : true;
    }

    displayProfileDataEventHandler() {
        console.debug('PortalView.displayProfileDataEventHandler()');

        if (!this.model.data) {
            return;
        }

        if (this.model.data.success===true) {
            this.renderSuccessResponse();
        } else {
            this.renderFailureResponse();
        }
        this.toggleButtonDisability();
    }

    renderFailureResponse() {
        if (this.theMessage && this.model.data && this.model.data.error && this.model.data.error.message) {
            this.theMessage.textContent = this.model.data.error.message;
        } else {
            this.theMessage.textContent = 'We are unable to process your request due to unexpected technical difficulties. Please try again. Later.';
        }
        this.theMessage.style.display = 'block';
        this.actionButtonDiv.classList.remove('hidden');

        const backToAccountButton = document.getElementById('backToAccountButton');
        if (backToAccountButton) {
            backToAccountButton.style.display = 'inline';
        }
    }

    renderSuccessResponse() {
        this.theMessage.textContent = '';
        this.theMessage.style.display = 'none';

        if (this.model.data.metadata.form_mode && this.model.data.metadata.form_mode==='show') {
            this.formMode = 'show';
        }
        if (this.isFirstTime===true && this.startsWithEditMode()===true) {
            this.isFirstTime = false;
            this.formMode = 'edit';
        }

        if (this.model.data.metadata && this.model.data.metadata.profile_fields) {
            const fieldsForEachHandler = function(name) {
                let profileFieldName = name;
                let value = this.model.data.profile[profileFieldName];
                if (name==='country_code') {
                    profileFieldName = 'country';
                    value = this.model.data.profile['country'];
                    this.populateStateCountryOptions();
                } else if (name==='state_code') {
                    value = this.model.data.profile['state'];
                } else if (name==='timezone') {
                    value = this.model.getTimezoneDisplayValue();
                    this.populateTimezoneOptions();
                }
                this.populateDataToDom(name, value);
            }
            this.model.data.metadata.profile_fields.forEach(fieldsForEachHandler.bind(this));
        }

        if (this.model.data.metadata && this.model.data.metadata.is_eligible_for_mfa===false && this.theForm['enable_mfa']) {
            let parentElement = this.theForm['enable_mfa'].parentElement;
            while (parentElement) {
                if (parentElement.tagName==='DIV' && parentElement.classList.contains('row')) {
                    parentElement.remove();
                    break;
                } else {
                    parentElement = parentElement.parentElement;
                }
            }
        }

        this.toggleContactDisplay();
        this.toggleButtonDisplay();

        this.displayDataFormRow();
        const changePasswordButton = document.getElementById('changePasswordButton');
        if (changePasswordButton && 
                changePasswordButton.hasChildNodes() && changePasswordButton.children[0].tagName==='A' && 
                this.model.data.metadata && 
                this.model.data.metadata.change_password_url!==undefined && 
                this.model.data.metadata.change_password_url) {
            changePasswordButton.children[0].href = this.model.data.metadata.change_password_url;
        }

        this.toggleButtonDisplay();
    }

    populateStateCountryOptions() {
        console.debug('populateStateCountryOptions()');
        const selectedCountryCode = this.model.data.profile['country_code']
        const selectedStateCode = this.model.data.profile['state_code']
        const countryCodeElement = this.theForm['country_code'];
        const stateCodeElement = this.theForm['state_code'];
        if (this.model.data.metadata.country_state) {
            const statesForEachHandler = function(item) {
                stateCodeElement[stateCodeElement.options.length] = new Option(item.label, item.value, selectedStateCode===item.value, selectedStateCode===item.value);
            }
            const countryStateForEachHandler = function (item) {
                countryCodeElement[countryCodeElement.options.length] = new Option(item.label, item.value, selectedCountryCode===item.value, selectedCountryCode===item.value);
                if (item.states && countryCodeElement.selectedIndex>0 && countryCodeElement.value===item.value) {
                    item.states.forEach(statesForEachHandler);
                }
            }
            this.model.data.metadata.country_state.forEach(countryStateForEachHandler);
        }
    }

    populateTimezoneOptions = function() {
        console.debug('populateTimezoneOptions()');
        const selectedTimezone = this.model.data.profile['timezone'];
        const timezoneElement = this.theForm['timezone'];
        if (this.model.data.metadata.timezone) {
            const timezonesForEachHandler = function(item) {
                timezoneElement[timezoneElement.options.length] = new Option(item.value, item.web_code, selectedTimezone===item.web_code, selectedTimezone===item.web_code);
            }
            this.model.data.metadata.timezone.forEach(timezonesForEachHandler);
        }
    }

    populateDataToDom(name, value) {
        const element = this.theForm[name];
        if (element && element.tagName==='INPUT') {
            element.value = value;
        }

        if (element && element.parentElement && element.parentElement.childElementCount>0) {
            if (element.tagName==='INPUT' && element.name==='email' && value) {
                IllumioDomUtils.removeChildren(element.parentElement.children[0]);

                const anchorElement = document.createElement('a');
                anchorElement.href = 'mailto:' + value;
                anchorElement.textContent = (value) ? value : '&nbsp;';
                element.parentElement.children[0].appendChild(anchorElement);
            } else if (element.tagName==='INPUT' && element.name==='enable_mfa') {
                element.checked = (value && value===true) ? true : false;
            } else if (value) {
                element.parentElement.children[0].textContent = value;
            } else {
                element.parentElement.children[0].innerHTML = '&nbsp;';
            }
        }
    }

    displayDataFormRow() {
        // Display contact rows
        for (let i=0;i<this.contactDivs.length;i++) {
            this.contactDivs[i].classList.remove('hidden');
        }
        if (this.model.data && this.model.data.metadata && this.model.data.metadata.full_profile) {
            // Display the full profile rows
            for (let i=0;i<this.fullProfileDivs.length;i++) {
                this.fullProfileDivs[i].classList.remove('hidden');
            }
        }
    }

    toggleButtonDisplay() {
        if (this.actionButtonDiv && this.formMode) {
            for (let i=0;i<this.actionButtonDiv.children.length;i++) {
                const element = this.actionButtonDiv.children[i];

                if (element.dataset['action']===this.formMode && (element.tagName==='BUTTON' || (element.tagName==='A' && element.href!==document.URL))) {
                    element.style.display = 'inline';
                } else {
                    element.style.display = 'none';
                }

                if (element.id==='backToAccountButton') {
                    element.style.display = (this.model.data && this.model.data.metadata.full_profile===false) ? 'inline' : 'none';
                }
            }
            this.actionButtonDiv.classList.remove('hidden');
        }
    }

    toggleButtonDisability() {
        if (this.actionButtonDiv) {
            for (let i=0;i<this.actionButtonDiv.childElementCount;i++) {
                if (this.actionButtonDiv.children[i].tagName==='BUTTON') {
                    this.actionButtonDiv.children[i].disabled = !this.actionButtonDiv.children[i].disabled;
                }
            }
        }
    }

    toggleContactDisplay() {
        console.debug('toggleContactDisplay()');
        const elements = this.theForm.elements;
        for (let i=0;i<elements.length;i++) {
            const element = elements[i];
            if (element.tagName==='INPUT' || element.tagName==='SELECT') {
                switch (this.formMode) {
                    case 'show':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = 'block';
                        element.style.display = 'none';
                        if (element.type==='checkbox') {
                            if (element.nextElementSibling) {
                                element.nextElementSibling.style.display = 'none';
                            }
                            if (element.name==='enable_mfa' && element.previousElementSibling) {
                                element.previousElementSibling.textContent = (element.checked) ? 'Enabled' : 'Disabled';
                            }
                        }
                        break;
                    case 'edit':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = (element.name==='email') ? 'block' : 'none';
                        element.style.display = (element.name==='email') ? 'none' : 'inline';
                        if (element.type==='checkbox' && element.nextElementSibling) {
                            element.nextElementSibling.style.display = 'inline';
                        }
                        break;
                    case 'new':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = 'none';
                        element.style.display = 'inline';
                        break;
                }
                if (element.name==='email') {
                    element.type = (this.formMode==='new') ? 'email' : 'hidden';
                    element.required = (this.formMode==='new') ? 'required' : '';
                    if (element.parentElement.previousElementSibling) {
                        element.parentElement.previousElementSibling.style.display = (this.formMode==='new') ? 'inline' : 'none';
                    }
                }
            }
        }
        if (this.formMode!=='show') {
            const stateCodeHasOptions = this.theForm['state_code'].options.length>1;
            this.theForm['state_code'].disabled = (stateCodeHasOptions) ? false : true;
        }
    }
}

export class ProfileController {
    constructor(model, view) {
        this.model = model;
        this.view = view;
    }
}

// const ProfileUtils = {
//     formatPhone: function(phone) {
//         var cleansedPhone = phone.trim();
//         var digitOnlyString = cleansedPhone.replace(/\D/g, '');
//         if ( (cleansedPhone.match(/^(\+)?1/) && digitOnlyString.match(/^\d{11}$/) && digitOnlyString.match(/^1/)) ||
//              (digitOnlyString.match(/^\d{10}$/) && !digitOnlyString.match(/^1/) && !cleansedPhone.match(/\+/)) ) {
//             var matchedData = digitOnlyString.match(/^1?(\d{3})(\d{3})(\d{4})$/);
//             if (matchedData) {
//                 return '(' + matchedData[1] + ') ' + matchedData[2] + '-' + matchedData[3];
//             };
//         }
//     
//         return cleansedPhone;
//     },
// }
